<template>
    <div>
        <div class="header-return">
            <el-row :gutter="20">
                <el-col :span="2">
                    <el-button type="text" icon="el-icon-arrow-left" @click="returnHistory">返回</el-button>
                </el-col>
                <el-col :span="2" :offset="20">
                    <el-button type="primary" @click="add()" size="mini" class="header-btn">新建</el-button>
                </el-col>
            </el-row>
        </div>
        <el-table :data="list" stripe border center :size="GCONFIG.styleTableSize">
            <el-table-column type="index" label="序号" width="50"></el-table-column>
            <el-table-column label="id" prop="id"></el-table-column>
            <el-table-column label="字段分类" prop="tagTypeName"></el-table-column>
            <el-table-column label="过滤条件" prop="name">
            </el-table-column>
            <el-table-column label="操作" fixed="right" width="220">
                <template slot-scope="scope">
                    <el-button-group>
                        <el-button type="success" size="mini" @click="edit(scope.row)">修改</el-button>
                        <el-button type="danger" size="mini" @click="handleDel(scope.row)">删除</el-button>
                    </el-button-group>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-wrap">
            <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="formInline.currentPage"
                    :page-sizes="GCONFIG.pageSizes"
                    :page-size="formInline.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="recordsTotal">
            </el-pagination>
        </div>
        <el-dialog title="设置" :visible.sync="showDialog">
            <el-form :model="model" label-width="120px">
                <el-form-item label="过滤条件" prop="type">
                    <el-select v-model="model.name"  placeholder="过滤条件">
                        <el-option v-for="item in tagClassList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.name">
                        </el-option>
                    </el-select>
                    <span style="color: red">*</span>
                </el-form-item>
                <el-form-item label="字段分类" prop="type">
                    <el-select v-model="model.tagType"  placeholder="字段分类">
                        <el-option v-for="item in tagTypeList"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    <span style="color: red">*tag分类 </span>
                </el-form-item>
                <el-form-item>
                    <el-button @click="showDialog = false">取 消</el-button>
                    <el-button type="primary" @click="save()" class="header-btn">
                        保存
                    </el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>
<script>
    //导入 HTTP请求方法
    import {
        getRuleTypeListApi, deleteRuleTypeApi, saveRuleTypeApi
    } from '../../api/api';
    export default {
        data() {
            return {
                showDialog: false,
                formInline: {
                    currentPage: 1,
                    pageSize: 20,
                    tagType: 0,
                    name: ''
                },
                list: [],
                tagTypeList:[{id:1,name:'文本'},{id:2,name:'日期'},{id:3,name:'整形'},{id:4,name:'金额'},{id:5,name:'选项'},{id:6,name:'是否'}],//过滤字段类型
                tagClassList:[{id:1,name:'大于'},{id:2,name:'大于等于'},{id:3,name:'小于'},{id:4,name:'小于等于'},{id:5,name:'包含'},{id:6,name:'不包含'}],
                model: {
                    name: '',
                    id:0,
                    tagType:0
                },
                loading: true,
                recordsTotal: 0,
                rules: {
                    name: [
                        {required: true, message: '请输入名称', trigger: 'blur'},
                        {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
                    ]
                }
            }
        },
        created() {
        },
        //挂载时候执行
        mounted(){
            this.getList();
        },
        methods: {
            getList(){
                //查询模板列表
                getRuleTypeListApi(this.formInline).then((res) => {
                    console.log(res);
                    if (res.data.success) {
                        this.list = res.data.value.list;
                        this.recordsTotal =res.data.value.total;
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                });
            },
            handleSizeChange(val) {
                this.formInline.pageSize = val;
                this.getList()
            },
            handleCurrentChange(val) {
                this.formInline.currentPage = val;
                this.getList()
            },
            add(){
                this.model = {
                    name: '',
                    id:0,
                    tagType:0
                };
                this.showDialog = true;
            },
            edit(row){
                this.model = {
                    name: row.name,
                    id:row.id,
                    tagType:row.tagType
                };
                this.showDialog = true;
            },
            save(){
                //名称判空
                if(this.model.name==''){
                    this.$message({
                        message: '过滤条件字段必选',
                        type: 'error'
                    });
                    return;
                }
                if(this.model.tagType==0){
                    this.$message({
                        message: '分类字段必选',
                        type: 'error'
                    });
                    return;
                }

                this.loading=true;
                //保存
                saveRuleTypeApi(this.model).then((res) => {
                    console.log(res);
                    this.loading=false;
                    if (res.data.success) {
                        this.getList();
                    } else {
                        this.$message({
                            message: res.data.message,
                            type: 'error'
                        });
                    }
                    this.showDialog = false;
                });
            },
            handleDel(row){
                //删除
                this.$confirm('删除不可撤销, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteRuleTypeApi({id:row.id}).then((res) => {
                        console.log(res);
                        if (res.data.success) {
                            this.$message({
                                showClose: true,
                                message: '成功',
                                type: 'success'
                            });
                            this.getList();
                        } else {
                            this.$message({
                                message: res.data.message,
                                type: 'error'
                            });
                        }
                        this.showDialog = false;
                    });
                })
            },
            returnHistory(){
                window.history.back()
            }
        }
    }
</script>
<style>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }

    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>


// WEBPACK FOOTER //
// src/views/sms/tagTypeRule.vue